export interface TravellerBudgetLine {
  employeeId: string
  displayName: string
  perNightPerRoom: number | null // hotel
  perLeg: number | null // flight
  perDay: number | null // car hire
  hasPolicy: boolean
  currencyCode: string | null
}

export function deriveHotelPerNightPerRoom(
  row: App.BusinessTraveller.ItemPolicyEvaluationRow,
  numberOfNights: number,
  roomCount: number,
): number | null {
  if (row.verdict === 'NO_POLICY' || row.applicableBudget == null) {
    return null
  }
  const divisor = numberOfNights * roomCount
  if (divisor <= 0) {
    return null
  }
  return row.applicableBudget / divisor
}

export function deriveFlightPerLeg(
  row: App.BusinessTraveller.ItemPolicyEvaluationRow,
  legMultiplier: number,
): number | null {
  if (row.verdict === 'NO_POLICY' || row.applicableBudget == null) {
    return null
  }
  if (legMultiplier <= 0) {
    return null
  }
  return row.applicableBudget / legMultiplier
}

export function getFlightLegMultiplier(flightViewType?: 'oneWay' | 'return' | 'multiCity'): number {
  // Item-policy flight budgets do not support multi-city yet; treat it as a single active leg for now.
  return flightViewType === 'return' ? 2 : 1
}

export function getEmployeeDisplayName(
  employees: Record<string, App.BusinessTraveller.EmployeeFromMeEndpoint | undefined>,
  employeeId: string,
): string {
  const employee = employees[employeeId]
  if (!employee) {
    return employeeId
  }
  return `${employee.firstName} ${employee.lastName}`.trim()
}
